import React, { useMemo } from 'react';
import DeterministicRandom from 'seedrandom';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import BorderIcons from '../icons/borders';

import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/partials/borders.scss';

const propTypes = {
    seed: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    hidden: PropTypes.bool,
    random: PropTypes.bool,
    borders: AppPropTypes.borders,
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
};

const defaultProps = {
    seed: 1,
    hidden: false,
    random: false,
    borders: {
        top: true,
        right: true,
        bottom: true,
        left: true,
    },
    className: null,
};

const patternGenerator = id => {
    const probability = DeterministicRandom(id)();

    return {
        TopLeft: probability < 0.4,
        TopRight: probability > 0.4,
        BottomLeft: probability > 0.8,
        BottomRight: probability < 0.6,

        LeftTop: probability > 0.4,
        RightTop: probability < 0.4,
        LeftBottom: probability < 0.2,
        RightBottom: probability > 0.6,
    };
};

const Borders = ({ seed, random, hidden, className, borders, children }) => {
    const patternSeed = useMemo(() => {
        return random ? Math.random() * 1000 + seed : seed;
    }, [seed, random]);

    const TopLeft = BorderIcons.horizontal.medium;
    const TopRight = BorderIcons.horizontal.medium;

    const BottomLeft = BorderIcons.horizontal.medium;
    const BottomRight = BorderIcons.horizontal.medium;

    const RightTop = BorderIcons.vertical.medium;
    const RightBottom = BorderIcons.vertical.medium;

    const LeftTop = BorderIcons.vertical.medium;
    const LeftBottom = BorderIcons.vertical.medium;

    const pattern = patternGenerator(patternSeed);

    if (hidden) {
        return children;
    }

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            {TopLeft && pattern.TopLeft && borders.top ? (
                <TopLeft className={classNames([styles.border, styles.topLeft])} />
            ) : null}
            {TopRight && pattern.TopRight && borders.top ? (
                <TopRight className={classNames([styles.border, styles.topRight])} />
            ) : null}
            {BottomLeft && pattern.BottomLeft && borders.bottom ? (
                <BottomLeft className={classNames([styles.border, styles.bottomLeft])} />
            ) : null}
            {BottomRight && pattern.BottomRight && borders.bottom ? (
                <BottomRight className={classNames([styles.border, styles.bottomRight])} />
            ) : null}
            {LeftTop && pattern.LeftTop && borders.left ? (
                <LeftTop className={classNames([styles.border, styles.topLeft])} />
            ) : null}
            {RightTop && pattern.RightTop && borders.right ? (
                <RightTop className={classNames([styles.border, styles.topRight])} />
            ) : null}
            {LeftBottom && pattern.LeftBottom && borders.left ? (
                <LeftBottom className={classNames([styles.border, styles.bottomLeft])} />
            ) : null}
            {RightBottom && pattern.RightBottom && borders.right ? (
                <RightBottom className={classNames([styles.border, styles.bottomRight])} />
            ) : null}
            {children}
        </div>
    );
};

Borders.propTypes = propTypes;
Borders.defaultProps = defaultProps;

export default Borders;
